import { StoreItem } from '../store/types';
import { CampaignStoreItemTypes, DynamicCampaignStoreItemOrAthon } from '../store/types/utils';

const storeItemWithCrowdfundingType = <T extends CampaignStoreItemTypes | StoreItem>(
  storeItem: T
): DynamicCampaignStoreItemOrAthon<T> => {
  const type = storeItem.type.toLowerCase();
  const campaignType = type.split('::')[1].toLowerCase();
  return {
    ...storeItem,
    __type: campaignType,
  } as unknown as DynamicCampaignStoreItemOrAthon<T>;
};

export { storeItemWithCrowdfundingType };
